<template>

  <!-- Dispatched (DISPATCHED, DISPATCHED_EDITING) -->
  <route-list-data-table
      title="Upcoming Deliveries"
      defaultSortField="delivery_date"
      defaultSortOrder="asc"
      :myRoutes="true"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      routeClickGoTo="route-info" />

</template>

<script>
import RouteListDataTable from '@/components/routes/RouteListDataTable'

export default {
  name: 'DeliveryListDispatchedPage',

  components: {
    RouteListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name', width: '180px' },
        { text: 'Orders', sortable: false, value: 'orders', width: '170px' },
        { text: 'Actions', sortable: false, align: 'center', value: 'id' },
        { text: 'Delivery Date', value: 'delivery_date' },
        { text: 'Start At', value: 'scheduled_start_time' },
        { text: 'Est. Return', value: 'estimated_return_time' },
        { text: 'Driver', value: 'driver_user_id' },
        { text: 'Vehicle', value: 'vehicle_id' },
        { text: 'Dispatched', value: 'dispatched_at' },
        { text: 'Status', value: 'route_status' }
      ],
      status: ['DISPATCHED', 'DISPATCHED_EDITING'],
      assocs: 'orders,driver,vehicle'
    }
  }
}
</script>

<style scoped>
</style>
